// opervex-frontend/src/Opervex/MaterialManagement/StorageLocation.js

class StorageLocation {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  // Create
  async create(data) {
    return this.#_api.post("/MaterialManagement/StorageLocation/", data);
  }

  // Update
  async update(id, data) {
    return this.#_api.put("/MaterialManagement/StorageLocation/" + id, data);
  }

  // Find By Id
  async findId(id) {
    return this.#_api.get("/MaterialManagement/StorageLocation/" + id);
  }

  // Find All
  async findAll() {
    return this.#_api.get("/MaterialManagement/StorageLocation");
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "acronym",
        label: "Sigla",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inativo",
        type: "boolean",
        visible: true,
        hidden: true,
      },
      {
        key: "type",
        label: "Tipo",
        type: "number",
        visible: true,
        hidden: true,
      },
    ];
  }
}
export default StorageLocation;
